import * as React from "react";
import { IconButton, Menu, MenuItem, styled } from "@mui/material";
import { useHistory } from "react-router";
import { CommonBackButton } from "../components/uiControllers/commonBackButton";
import { useCallback, useRef, useState } from "react";
import HomeIcon from "@mui/icons-material/Home";
import { PatientRoute } from "../PatientRoutes/PatientRoute";
import RestorePageOutlinedIcon from "@mui/icons-material/RestorePageOutlined";
import { isProduction } from "fe-common/utils/envGetter";

//region [[ Styles ]]

const KahunWidgetNavigationBarView = styled("div")({
  display: "flex",
  flexFlow: "row",
  justifyContent: "space-between",
});

const Icons = styled("div")({
  display: "flex",
  flexFlow: "row",
  alignItems: "center",
});

const GoToUrlButton = styled(MenuItem)({
  fontSize: "9px",
  background: "#efefef",
  borderRadius: "8px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  "& svg": {
    height: "14px",
    width: "14px",
    margin: "0 5px",
  },
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface KahunWidgetNavigationBarProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const KahunWidgetNavigationBar = ({
  ...props
}: KahunWidgetNavigationBarProps) => {
  const [allowForward, setAllowForward] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuAnchor = useRef();

  const history = useHistory();
  const handleBackClicked = useCallback(() => {
    if (history.length !== 1) {
      setAllowForward((old) => ++old);
      setTimeout(() => history.goBack(), 200);
    }
  }, [history]);

  const handleForwardClicked = useCallback(() => {
    setAllowForward((old) => --old);
    setTimeout(() => history.go(1), 200);
  }, [history]);

  const goToHome = useCallback(() => {
    history.push("/");
  }, [history]);

  const goToRoute = useCallback(
    (route: PatientRoute) => {
      setIsMenuOpen(false);
      history.push(route);
    },
    [history],
  );

  return (
    <KahunWidgetNavigationBarView className={"widget-navigation"}>
      <CommonBackButton className={"back-button"} onClick={handleBackClicked} />
      <Icons>
        <IconButton onClick={goToHome}>
          <HomeIcon />
        </IconButton>
        {!isProduction() && (
          <span style={{ padding: "3px", fontSize: "9px" }}>
            (env: {process.env.REACT_APP_ENVIRONMENT})
          </span>
        )}
        <GoToUrlButton ref={menuAnchor} onClick={() => setIsMenuOpen(true)}>
          <RestorePageOutlinedIcon />
          Go to url
        </GoToUrlButton>
        <Menu
          style={{
            zIndex: 1999,
          }}
          open={isMenuOpen}
          onClose={() => setIsMenuOpen(false)}
          anchorEl={menuAnchor.current}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          {Object.entries(PatientRoute).map(([k, v]) => (
            <MenuItem onClick={() => goToRoute(v)}>{k}</MenuItem>
          ))}
        </Menu>
      </Icons>
      {allowForward > 0 && (
        <CommonBackButton
          className={"forward-button"}
          onClick={handleForwardClicked}
          forward
        />
      )}
      {allowForward === 0 && <div />}
    </KahunWidgetNavigationBarView>
  );
};
